import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
  CeoClothingLossDecisionPayload,
  CeoPendingLossCase,
  HeadClothingLossDecisionPayload,
  HeadPendingLossCase
} from '../models/clothing.model';

type ClothingLossDecisionPayload =
  HeadClothingLossDecisionPayload | CeoClothingLossDecisionPayload;

var HEAD_MODE = 'head';
var CEO_MODE = 'ceo';

@Component({
  selector: 'app-clothing-head-loss-decision-modal',
  templateUrl: './clothing-head-loss-decision-modal.component.html',
  styleUrls: ['./clothing-head-loss-decision-modal.component.css']
})
export class ClothingHeadLossDecisionModalComponent {
  public mode = HEAD_MODE;
  public employeeFullName = '';
  public itemName = '';
  public employeeDescription = '';
  public headDecisionDescription = '';
  public calculatedPenaltyUsd = 0;
  public calculatedPenaltyByn = 0;
  public decisionDescription = '';

  constructor(public activeModal: NgbActiveModal) {}

  setHeadValues(lossCase: HeadPendingLossCase): void {
    this.mode = HEAD_MODE;
    this.employeeFullName = lossCase.employeeFullName;
    this.itemName = lossCase.catalogItemName;
    this.employeeDescription = lossCase.description || '';
    this.headDecisionDescription = '';
    this.calculatedPenaltyUsd = lossCase.calculatedPenaltyUsd || 0;
    this.calculatedPenaltyByn = 0;
  }

  setCeoValues(lossCase: CeoPendingLossCase): void {
    this.mode = CEO_MODE;
    this.employeeFullName = lossCase.employeeFullName;
    this.itemName = lossCase.catalogItemName;
    this.employeeDescription = lossCase.employeeDescription || '';
    this.headDecisionDescription = lossCase.headDecisionDescription || '';
    this.calculatedPenaltyUsd = lossCase.calculatedPenaltyUsd || 0;
    this.calculatedPenaltyByn = lossCase.calculatedPenaltyByn || 0;
  }

  confirmRespectful(): void {
    this.activeModal.close(this.createPayload(this.getPrimaryDecisionType()));
  }

  confirmUnrespectful(): void {
    this.activeModal.close(this.createPayload(this.getSecondaryDecisionType()));
  }

  cancel(): void {
    this.activeModal.dismiss();
  }

  hasEmployeeDescription(): boolean {
    return !!this.employeeDescription && !!this.employeeDescription.trim().length;
  }

  hasHeadDecisionDescription(): boolean {
    return !!this.headDecisionDescription && !!this.headDecisionDescription.trim().length;
  }

  hasPenalty(): boolean {
    return this.calculatedPenaltyUsd > 0;
  }

  hasPenaltyByn(): boolean {
    return this.calculatedPenaltyByn > 0;
  }

  isHeadMode(): boolean {
    return this.mode === HEAD_MODE;
  }

  getTitleKey(): string {
    if (this.isHeadMode()) {
      return 'CLOTHING_HEAD_LOSS_DECISION_TITLE';
    }
    return 'CLOTHING_CEO_LOSS_DECISION_TITLE';
  }

  getDescriptionLabelKey(): string {
    if (this.isHeadMode()) {
      return 'CLOTHING_HEAD_DECISION_DESCRIPTION';
    }
    return 'CLOTHING_CEO_DECISION_DESCRIPTION';
  }

  getPrimaryActionKey(): string {
    if (this.isHeadMode()) {
      return 'CLOTHING_WRITE_OFF_ACTION';
    }
    return 'CLOTHING_CEO_WRITE_OFF_FREE_ACTION';
  }

  getSecondaryActionKey(): string {
    if (this.isHeadMode()) {
      return 'CLOTHING_CHARGE_EMPLOYEE_ACTION';
    }
    return 'CLOTHING_CEO_DEDUCT_FROM_PAYROLL_ACTION';
  }

  private createPayload(decisionType: string): ClothingLossDecisionPayload {
    return {
      decisionType: decisionType,
      description: this.resolveDecisionDescription()
    };
  }

  private resolveDecisionDescription(): string {
    if (!this.decisionDescription) {
      return '';
    }
    return this.decisionDescription.trim();
  }

  private getPrimaryDecisionType(): string {
    if (this.isHeadMode()) {
      return 'RESPECTFUL';
    }
    return 'WRITE_OFF_FOR_FREE';
  }

  private getSecondaryDecisionType(): string {
    if (this.isHeadMode()) {
      return 'UNRESPECTFUL';
    }
    return 'DEDUCT_FROM_PAYROLL';
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/modals/clothing-head-loss-decision-modal.component.ts